import { SelectHTMLAttributes, ReactNode } from 'react';

const selectClasses = 'py-1.5 sm:py-2 px-3 border-1 block w-full bg-field border-border rounded-sm sm:text-sm text-onfield placeholder:text-onfield/30 focus:z-10 focus:border-primary focus:ring-primary focus:outline-none disabled:opacity-50 disabled:pointer-events-none pe-9 cursor-pointer appearance-none';

export interface SelectDropdownProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode;
  className?: string;
}

export function SelectDropdown({ 
  children, 
  className = '', 
  ...selectProps 
}: SelectDropdownProps) {
  return (
    <div className="relative">
      <select
        className={`${selectClasses} ${className}`}
        {...selectProps}
      >
        {children}
      </select>
      <div className="absolute top-1/2 end-2.5 -translate-y-1/2 pointer-events-none">
        <svg
          className="shrink-0 size-3.5 opacity-50"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m7 15 5 5 5-5" />
          <path d="m7 9 5-5 5 5" />
        </svg>
      </div>
    </div>
  );
}
